import React from 'react';
import { Paperclip } from '@/components/Icons/Paperclip';

interface Props {
  count: number;
}

export const AttachmentCountBadge: React.FC<Props> = ({ count }) => (
  <span className="flex shrink-0 items-center gap-1 rounded-2xl bg-info-surface py-1 pr-2 pl-1 text-caption-12 text-primary">
    <Paperclip className="size-4 shrink-0" />
    {count}
  </span>
);
